import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Row, Col, Select, Switch } from 'antd';
import useApi from '../../hooks/useApi';
import useUserType from '../../hooks/useUserType';

const { TextArea } = Input;

const ModalEdit = ({ visible, id, onCancel, onSuccess, initialData }) => {
  const [form] = Form.useForm();
  const [departamentos, setDepartamentos] = useState([]);
  const userType = useUserType();
  
  const { callApi: editDashboard } = useApi(`https://vision.alfama.com/api/update/dashboards/${id}`, {
    method: 'PUT',
    includeToken: true,
    successMessage: 'Dashboard atualizado com sucesso!',
    errorMessage: 'Erro ao atualizar dashboard'
  });
  
  const { callApi: viewDepartamentos } = useApi('https://vision.alfama.com/api/view/departamentos/ativos', { 
    includeToken: true,
  });
  
  useEffect(() => {
    const fetchDepartamentos = async () => {
      try {
        const response = await viewDepartamentos();
        if (response && Array.isArray(response)) {
          const formattedDepartamentos = response.map(departamento => ({
            value: departamento.departamento_id,
            label: departamento.nome_departamento
          }));
          setDepartamentos(formattedDepartamentos);
        }
      } catch (error) {
        console.error('Erro ao buscar departamentos:', error);
      }
    };
    
    fetchDepartamentos();
  }, []);

  useEffect(() => {
    if (initialData) {
      form.setFieldsValue({
        nome: initialData.nome,
        departamento: initialData.departamento_id,
        descricao: initialData.descricao,
        workspace_id: initialData.workspace_id,
        report_id: initialData.report_id,
        has_rls: initialData.has_rls_id === 1,
        homologado_id: initialData.homologado_id === 1,
        situacao: initialData.status === 'ativo',
      });
    }
  }, [initialData, form]);
  
  const handleConfirm = async () => {
    try {
      const values = await form.validateFields();
      
      const dataToSend = {
        ...values,
        has_rls: values.has_rls ? 1 : 0,
        homologado_id: values.homologado_id ? 1 : 0,
        situacao: values.situacao ? 1 : 0
      };
      
      await editDashboard(dataToSend);
      form.resetFields();
      onCancel();
      onSuccess();
    } catch (error) {
      if (error.errorFields) {
        return;
      }
      console.error('Erro ao editar dashboard:', error);
    }
  };
  
  return (
    <Modal
      title={`Editar Dashboard - ID: ${id}`}
      open={visible}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={handleConfirm}
      okText="Salvar"
      cancelText="Cancelar"
      width={800}
    >
      <Form
        form={form}
        layout="vertical"
      >
        <Row gutter={16}>
          <Col span={7}>
            <Form.Item
              name="nome"
              label="Nome"
              rules={[{ required: true, message: 'Por favor, insira o nome do dashboard' }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="departamento"
              label="Departamento"
              rules={[{ required: true, message: 'Por favor, selecione um departamento' }]}
            >
              <Select
                placeholder="Selecione um departamento"
                options={departamentos}
                loading={departamentos.length === 0}
              />
            </Form.Item>
          </Col>
          <Col span={4}>
                      <Form.Item
                        name="situacao"
                        label="Situação"
                        valuePropName="checked"
                      >
                        <Switch 
                          checkedChildren="Ativo" 
                          unCheckedChildren="Bloqueado"
                        />
                      </Form.Item>
                    </Col>
          <Col span={4}>
            <Form.Item
              name="homologado_id"
              label="Homologado"
              valuePropName="checked"
            >
              <Switch 
                checkedChildren="Sim" 
                unCheckedChildren="Não"
              />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={24}>
            <Form.Item
              name="descricao"
              label="Descrição"
              rules={[{ required: true, message: 'Por favor, insira a descrição do dashboard' }]}
            >
              <TextArea rows={4} />
            </Form.Item>
          </Col>
        </Row>

        <Row gutter={16}>
          <Col span={9}>
            <Form.Item
              name="workspace_id"
              label="Workspace ID"
              rules={[{ required: true, message: 'Por favor, insira o Workspace ID' }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={9}>
            <Form.Item
              name="report_id"
              label="Report ID"
              rules={[{ required: true, message: 'Por favor, insira o Report ID' }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="has_rls"
              label="RLS"
              valuePropName="checked"
            >
              <Switch 
                checkedChildren="Sim" 
                unCheckedChildren="Não"
              />
            </Form.Item>
          </Col>
          
        </Row>
      </Form>
    </Modal>
  );
};

export default ModalEdit;